/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkerDto
 */
export interface WorkerDto {
    /**
     * The ID of the worker.
     * @type {number}
     * @memberof WorkerDto
     */
    id: number;
    /**
     * The endpoint of the worker.
     * @type {string}
     * @memberof WorkerDto
     */
    endpoint: string;
    /**
     * Indicates if an API key has been configured. The key itself is never exposed.
     * @type {boolean}
     * @memberof WorkerDto
     */
    hasApiKey: boolean;
}

/**
 * Check if a given object implements the WorkerDto interface.
 */
export function instanceOfWorkerDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "endpoint" in value;
    isInstance = isInstance && "hasApiKey" in value;

    return isInstance;
}

export function WorkerDtoFromJSON(json: any): WorkerDto {
    return WorkerDtoFromJSONTyped(json, false);
}

export function WorkerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'endpoint': json['endpoint'],
        'hasApiKey': json['hasApiKey'],
    };
}

export function WorkerDtoToJSON(value?: WorkerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'endpoint': value.endpoint,
        'hasApiKey': value.hasApiKey,
    };
}

